import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { allImages } from "../../assets";

function AllChats({ item, index, handleChatWidt }) {

  console.log(item?.user?.image, 'itemitemitem');

  return (
    <Stack
      onClick={() => handleChatWidt(item)}
      gap={2}
      direction={"row"}
      borderRadius={2}
      p={"8px 8px"}
      key={index}
      alignItems={"center"}
      bgcolor={"#615EF00F"}
      sx={{
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#F3F3F3",
        },
      }}
    >
      <Box borderRadius={100} overflow={"hidden"} width={48} height={48}>
        <img
          src={item?.user?.image || allImages.userAvatar}
          alt="image"
          width={"100%"}
          height={"100%"}
        />
      </Box>
      <Typography
        variant="body1"
        fontSize={"0.875rem"}
        fontWeight={"bold"}
        fontFamily={"Metropolis"}
      >
        {item?.user?.username}
      </Typography>
    </Stack>
  );
}

export default AllChats;
